module.exports = __webpack_public_path__ + "images/newerp_logo_w.1791972770245.png";